import React from "react";
import { formatCurrency } from "../UI/DesignStandards";
import { productLabel } from "../../utility/brackets/constants";
import { clampTicketCount } from "../../utility/brackets/entryTickets";

const BowlerBracketTickets = ({
  products,
  counts = {},
  onChange,
  disabled = false,
  isShuffled,
}) => {
  if (!products?.length) return null;
  const anyShuffled = products.some((product) => isShuffled?.(product));

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-brand-charcoal">
        Brackets
      </label>
      <div className="space-y-2">
        {products.map((product) => {
          const count = clampTicketCount(counts[product.id]);
          const locked = disabled || Boolean(isShuffled?.(product));
          return (
            <div
              key={product.id}
              className="flex items-center gap-3 rounded-lg border border-brand-charcoal/15 bg-white px-3 py-2"
            >
              <div className="min-w-0 flex-1">
                <div className="text-sm font-medium text-brand-charcoal truncate">
                  {productLabel(product)}
                </div>
                <div className="text-xs text-brand-muted">
                  {formatCurrency(Number(product.entryAmount) || 0)} each
                </div>
              </div>
              {locked ? (
                <span className="font-display font-bold text-brand-charcoal">
                  {count}
                </span>
              ) : (
                <div className="flex items-center gap-2 shrink-0">
                  <button
                    type="button"
                    className="h-11 w-11 rounded-lg border border-brand-charcoal/20 bg-white text-xl font-display font-bold disabled:opacity-40"
                    disabled={count === 0}
                    onClick={() => onChange(product.id, count - 1)}
                    aria-label={`Remove a ${productLabel(product)} ticket`}
                  >
                    −
                  </button>
                  <div className="w-8 text-center font-display font-bold">
                    {count}
                  </div>
                  <button
                    type="button"
                    className="h-11 w-11 rounded-lg bg-brand-charcoal text-brand-cream text-xl font-display font-bold"
                    onClick={() => onChange(product.id, count + 1)}
                    aria-label={`Add a ${productLabel(product)} ticket`}
                  >
                    +
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
      {disabled && !anyShuffled ? (
        <p className="text-xs text-brand-muted">
          Complete bowler name to add tickets.
        </p>
      ) : null}
      {anyShuffled ? (
        <p className="text-xs text-brand-muted">
          Trees are shuffled. Ticket counts cannot change.
        </p>
      ) : null}
    </div>
  );
};

export default BowlerBracketTickets;
